import {
	ComponentProps,
	CSSProperties,
	FC,
	JSXElementConstructor,
	ReactElement,
} from 'react';
import { Trans } from 'react-i18next';
import { Box, BoxProps } from '@mui/material';

import { TNamespace } from '../i18';

/* Add any tags you need in your translations */
const DEFAULT_COMPONENTS = {
	b: <b />,
	i: <i />,
	u: <u />,
	s: <s />,
	br: <br />,
} as const;

type TDefaultComponents = {
	readonly [tagName: string]: ReactElement<
		unknown,
		string | JSXElementConstructor<unknown>
	>;
};

type TTransProps = ComponentProps<typeof Trans>;

interface IMplTransProps extends TTransProps {
	i18nKey: string;
	ns?: TNamespace;
	components?: typeof DEFAULT_COMPONENTS | TDefaultComponents;
	boxComponent?: BoxProps['component'];
	boxWhiteSpace?: CSSProperties['whiteSpace'];
}

export const MplTrans: FC<IMplTransProps> = ({
	components,
	boxComponent = 'span',
	boxWhiteSpace = 'pre-line',
	...otherProps
}) => (
	<Box component={boxComponent} whiteSpace={boxWhiteSpace}>
		<Trans
			components={{ ...DEFAULT_COMPONENTS, ...components }}
			{...otherProps}
		/>
	</Box>
);
